import { useMemo } from 'react';

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rowData: any[];
  pageNumber: number;
  pageSize: number;
  totalItems?: number;
};

export const usePagination = ({ pageNumber, pageSize, rowData, totalItems }: Props) => {
  const paginatedData = useMemo(() => {
    if (
      !pageNumber ||
      !pageSize ||
      rowData.length === 0 ||
      pageNumber < 1 ||
      (pageNumber - 1) * pageSize >= rowData.length
    ) {
      return rowData;
    }

    const startIndex = (pageNumber - 1) * pageSize;
    return rowData.slice(startIndex, startIndex + pageSize);
  }, [pageNumber, pageSize, rowData]);

  const lastPageNumber = useMemo(() => {
    const elements = totalItems || rowData.length;
    if (elements === 0) {
      return 1;
    }
    return Math.ceil(elements / pageSize);
  }, [pageSize, rowData, totalItems]);

  return { paginatedData, lastPageNumber };
};
